import { render, staticRenderFns } from "./EditBenefitDetailsModal.vue?vue&type=template&id=3337adfa&scoped=true"
import script from "./EditBenefitDetailsModal.vue?vue&type=script&lang=js"
export * from "./EditBenefitDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./EditBenefitDetailsModal.vue?vue&type=style&index=0&id=3337adfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3337adfa",
  null
  
)

export default component.exports